module.exports = __webpack_public_path__ + "static/media/paperinvaders.228eef4d.webp";